<template>
  <div class=" sksjsqshDetail" type="0" :route="list.route">
    <Header title="授课数据申请审核详情"></Header>
    <h4>{{ list.KCMC }}({{ list.KCH }})</h4>
    <p>
      通知单编号：<b> {{ list.JX0404ID }}</b>
    </p>
    <p>
      开课学期：<b>{{ list.XNXQ01ID }}</b>
    </p>
    <p>
      开课单位：<b> {{ list.DWMC }}</b>
    </p>
    <p>
      课程开课学院：<b> {{ list.DWMC }}</b>
    </p>
    <p>
      课程属性：<b> {{ list.KCSX }}</b>
    </p>
    <p>
      选课人数：<b> {{ list.XKRS }}</b>
    </p>
    <p>
      总学时：<b> {{ list.ZXS }}</b>
    </p>
    <p>
      总学分：<b> {{ list.ZXF }}</b>
    </p>
    <p>
      上课周次：<b> {{ list.KKZC }}</b>
    </p>
    <p>
      上课星期：<b> {{ list.XQ }}</b>
    </p>
    <p>
      上课节次：<b> {{ list.JC }}</b>
    </p>
    <p>
      地点：<b> {{ list.JSMC }}</b>
    </p>
    <p>
      授课教师：<b> {{ list.XM }}</b>
    </p>
    <p>
      教工号：<b> {{ list.JGH }}</b>
    </p>
    <p>
      职称：<b> {{ list.JSZC }}</b>
    </p>
    <p>
      教师所在学院：<b> {{ list.JSYX }}</b>
    </p>
    <p>
      本人实际承担理论学时：<b> {{ list.LLXS }}</b>
    </p>
    <p>
      本人实际承担实践学时：<b> {{ list.SJXS }}</b>
    </p>
    <p>
      是否独立授课：<b> {{ list.DLSK }}</b>
    </p>
    <p>
      是否超过通知单学时：<b> {{ list.SFCGXS }}</b>
    </p>

    <div class="bottom-btn">
      <button @click="sh(1)">审核通过</button>
      <button @click="sh(0)">审核不通过</button>
    </div>
  </div>
</template>
<script>
import tApi from "../../../../utils/teacher";

export default {
  data() {
    return {
      list: []
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      const res = await tApi.getSksjsqById({
        ywinstanceid: this.$route.query.list.YWINSTANCEID
      });
      this.list = res.data[0];
    },
    async sh(flag) {
      const res = await tApi.sksjsqSh({
        state: flag,
        workId: this.list.YWINSTANCEID
      });

      if (res.code == "1") {
        this.$toast.success(res.Msg);
        setTimeout(() => {
          this.$router.back(0);
        }, 1500);
      } else {
        this.$toast.fail(res.Msg);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.sksjsqshDetail {
  height: 85vh;
  overflow: auto;
  padding: 20px;
}
.sksjsqshDetail h4 {
  color: @attendance-color-1;
  font-size: 18px;
  line-height: 25px;
  margin-bottom: 8px;
}
.sksjsqshDetail p {
  color: @attendance-color-2;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 8px;
}
.sksjsqshDetail .bottom-btn {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60px;
  padding: 0 5% 10px;
  background: #fff;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;

  button {
    display: block;
    height: 100%;
    width: 47.5%;
    background: #7469f8;
    border-radius: 3px;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/sksjsqsh/detail.vue